import { Close, Menu } from '@mui/icons-material';
import { Stack, Typography, useMediaQuery, Link, Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import Image from 'next/image';
import { useRouter } from 'next/navigation';
import React from 'react';
import { getRunTimeEnv } from '../../../util/getEnvVariable';
import getGeneralImage from '../../../util/getGeneralImage';
import { useStyles } from '../style';

/**
 * @name CartIcon
 * @description Cart icon of website
 * @param {object} root0  - destructured object
 * @param {object} root0.icons - Data from Strapi
 * @param {boolean} root0.expand - Data from Strapi
 * @param {Function} root0.handleExpand - Function for expanding nav list
 * @param {string} root0.cartTitle - Data from Strapi
 * @returns {JSX.Element} Next.js Image Element
 */
const CartIcon = ({ icons, expand, handleExpand, cartTitle }) => {
  const theme = useTheme();
  const styles = useStyles(theme);
  const sm = useMediaQuery(theme.breakpoints.down('md'));
  const router = useRouter();
  const clientSideEnv = getRunTimeEnv();

  return (
    <Stack direction='row' alignItems='center' justifyContent='flex-end'>
      <Link
        href=''
        onClick={() =>
          router.push(
            `${clientSideEnv.NEXT_PUBLIC_EIRIE || process.env.NEXT_PUBLIC_EIRIE}/shop/redirectSummary`,
          )
        }
        underline='hover'
        sx={{
          display: 'flex',
          alignItems: 'center',
          cursor: 'pointer',
          color: theme.palette.default.textColor3,
        }}
        onKeyDown={e => {
          if (e.key === ' ' || e.key === 'Enter') {
            e.preventDefault();
            e.currentTarget.click();
          }
        }}
      >
        {!sm && <Typography sx={styles.navTitle}>{cartTitle}</Typography>}
        <Image
          width={30}
          height={30}
          src={`${
            getGeneralImage({
              generalImageArray: icons,
              key: 'CartIcon',
              view: 'DesktopViewImage',
            }).url
          }`}
          alt='CartIcon'
          quality={100}
        ></Image>
      </Link>
      {sm &&
        (expand ? (
          <Box
            component='button'
            onClick={handleExpand}
            onKeyDown={e => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                handleExpand();
              }
            }}
            sx={{
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              padding: 0,
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <Close className='--prevent-collapse' aria-label='Close Menu' />
          </Box>
        ) : (
          <Box
            component='button'
            onClick={handleExpand}
            onKeyDown={e => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                handleExpand();
              }
            }}
            sx={{
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              padding: 0,
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <Menu className='--prevent-collapse' role='navigation' />
          </Box>
        ))}
    </Stack>
  );
};

CartIcon.displayName = 'CartIcon';
export default CartIcon;
